import { QuoteRatingSearchResponse } from '@lio/api-types';

import { ArrayItem } from '@utils/commonTypes';

export type QuoteRating = ArrayItem<QuoteRatingSearchResponse['items']>;

export type RatingStatus = QuoteRating['status'];

export const quoteRatingStatus: Record<RatingStatus, RatingStatus> = {
  Pending: 'Pending',
  InProgress: 'InProgress',
  Failed: 'Failed',
  Succeeded: 'Succeeded',
};
